import { ICON_USER } from '@global/constants';
import { RoutePaths } from '@global/routePaths';

export const offerSteps = [
  {
    id: 'offer',
    title: 'STEPS.OFFER.TITLE',
    iconClass: ICON_USER,
    steps: [
      // Offers
      {
        title: 'STEPS.OFFER.TITLE',
      },
    ],
    route: RoutePaths.NEW_QUOTATION.OFFER.route,
  },
];
